var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	53858: {
		fallback: () => (__webpack_require__.e(4644).then(() => (() => (__webpack_require__(96540))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^18.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	93888: {
		fallback: () => (__webpack_require__.e(4644).then(() => (() => (__webpack_require__(40961))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^18.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",

	},
	39817: {
		fallback: () => (__webpack_require__.e(4644).then(() => (() => (__webpack_require__(74848))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^18.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react/jsx-runtime",

	},
	46737: {
		fallback: () => (__webpack_require__.e(5942).then(() => (() => (__webpack_require__(75942))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^3.39.2",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-query",

	},
	51253: {
		fallback: () => (__webpack_require__.e(2648).then(() => (() => (__webpack_require__(92648))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^6.4.3",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-router-dom",

	},
	42164: {
		fallback: () => (Promise.all([__webpack_require__.e(6159), __webpack_require__.e(6030)]).then(() => (() => (__webpack_require__(73649))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "11.10.4",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@emotion/react",

	},
	4976: {
		fallback: () => (__webpack_require__.e(3860).then(() => (() => (__webpack_require__(71479))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "11.10.4",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@emotion/styled",

	},
	31488: {
		fallback: () => (__webpack_require__.e(6180).then(() => (() => (__webpack_require__(96180))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.31.3",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@toorak/op-web-tw-component",

	},
	25761: {
		fallback: () => (__webpack_require__.e(6203).then(() => (() => (__webpack_require__(56203))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.9.2",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "i18next",

	},
	87238: {
		fallback: () => (__webpack_require__.e(9041).then(() => (() => (__webpack_require__(35070))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^11.18.6",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-i18next",

	},
	52915: {
		fallback: () => (__webpack_require__.e(8496).then(() => (() => (__webpack_require__(18496))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^6.7.3",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@casl/ability",

	},
	26714: {
		fallback: () => (__webpack_require__.e(5584).then(() => (() => (__webpack_require__(73203))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@casl/react",

	},
	10399: {
		fallback: () => (__webpack_require__.e(9232).then(() => (() => (__webpack_require__(49232))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.18.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@mui/material",

	},
	11945: {
		fallback: () => (__webpack_require__.e(4420).then(() => (() => (__webpack_require__(54420))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.18.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@mui/styles",

	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"1488": [
		31488
	],
	"1747": [
		10399,
		11945
	],
	"1779": [
		52915,
		26714
	],
	"2164": [
		42164
	],
	"2406": [
		25761,
		87238
	],
	"3858": [
		53858
	],
	"3888": [
		93888
	],
	"4976": [
		4976
	],
	"9701": [
		46737,
		51253
	],
	"9817": [
		39817
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}